module.exports = __webpack_public_path__ + "static/img/slogan.7943c06.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/index1/slogan.png
// module id = yJQ4
// module chunks = 7